// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from './axios';
import { toast } from "sonner";
import { showSuccess, showError } from '../actions/globalActions';
import { LeagueInterface } from "@/interfaces/league";
import cookie from '../utils/cookie';
import getApiErrorMessage from '../utils/getApiErrorMessage';

const baseUrl = `${process.env.API_URL}/api/v1`;
// axios.defaults.headers.common['Authorization'] = `Bearer ${cookie.get('clerk_token')}`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const useLeagueStore = create(immer((set) => ({
  leagues: [],

  // Methods to manipulate the state
  setLeagues: (leagues: LeagueInterface[]) => {
    set((state) => {
      state.leagues = leagues;
    });
  },

  // Asynchronous actions
  getLeagueById: async (id: string, cb: Function) => {
    try {
      const { data } = await axios.get(`${baseUrl}/leagues/${id}?include=tournament`);
      set((state) => {
        const index = _.findIndex(state.leagues, { _id: id });
        if (index >= 0) {
          state.leagues[index] = data.result;
        } else {
          state.leagues.push(data.result);
        }
      });
      cb && cb(data.result);
    } catch (error) {
      console.error("Error in getLeagueById:", error);
    }
  },

  getLeaguesByOrganizationId: async (id: string) => {
    try {
      const { data } = await axios.get(`${baseUrl}/leagues/organization/${id}?include=tournament`);
      set((state) => {
        state.leagues = _.unionBy(data.result, state.leagues, '_id');
      });
    } catch (error) {
      console.error("Error in getLeaguesByOrganizationId:", error);
    }
  },

  // opts.contestType filters server-side ('season' → standalone seasons only;
  // the endpoint supports ?contestType= — league.controller.ts). Omit for all.
  getLeaguesByOrganizationName: async (name: string, opts?: { contestType?: string }) => {
    try {
      const qs = opts?.contestType ? `?contestType=${opts.contestType}` : '';
      const { data } = await axios.get(`${baseUrl}/leagues/organizationName/${name}${qs}`);
      set((state) => {
        state.leagues = _.unionBy(data.result, state.leagues, '_id');
      });
    } catch (error) {
      console.error("Error in getLeaguesByOrganizationName:", error);
    }
  },
  getContestsByTournamentId: async (id: string) => {
    try {
      const { data } = await axios.get(`${baseUrl}/leagues/tournament/${id}?include=config.paymentProduct,tournament`);
      set((state) => {
        state.leagues = _.unionBy(data.result, state.leagues, '_id');
      });
    } catch (error) {
      console.error("Error in getLeaguesByOrganizationName:", error);
    }
  },

  // getAllSeasons: async () => {
  //   try {
  //     const { data } = await axios.get(`${baseUrl}/leagues`);

  //     set((state) => {
  //       state.leagues = _.unionBy(data.result, state.leagues, '_id');
  //     });
  //   } catch (error) {
  //     console.error("Error in getAllSeasons:", error);
  //   }
  // },

  updateLeague: (getToken) => {
    return async (league: LeagueInterface, cb: Function) => {
      try {
        const token = await getToken();
        const { error, result, status } = (await axios.put(`${baseUrl}/leagues/${league._id}`, league, createAuthHeader(token))).data;
        error ? toast.error(error) : toast.success(`Successfully Updated!`);
        set((state) => {
          const index = state.leagues.findIndex(s => s._id === league._id);
          if (index !== -1) {
            state.leagues[index] = result;
          }
        });
        cb && cb(result);
      } catch (error) {
        if (!error.permissionToastShown) {
          showError('Error', getApiErrorMessage(error, 'Update Error'));
        }
        console.error("Error in updateLeague:", error);
      }
    }
  },

  addLeague: (getToken) => {
    return async (league: LeagueInterface) => {
      const token = await getToken();
      const { data } = await axios.post(`${baseUrl}/leagues`, league, createAuthHeader(token));
      set((state) => {
        state.leagues.push(data.result);
      });
    }
  },

  deleteLeague: (getToken) => {
    return async (id: string) => {
      try {
        const token = await getToken();
        const { data } = await axios.delete(`${baseUrl}/leagues/${id}`, createAuthHeader(token));
        if (data === 401 || data === 403) {
          return { error: "Unauthorized" };
        }
        console.log('deleteLeague::', data);
        toast.success(`Successfully Remove!`);
        set((state) => {
          state.leagues = state.leagues.filter(s => s._id !== id);
        });
      } catch (error) {
        showError('Error', 'Delete Error');
        console.error("Error in deleteLeague:", error);
        return { error: "Error deleting league" };
      }
    }
  },

  cloneLeague: (getToken) => {
    return async (id: string, leagueName: string, cloneDivisions: boolean = false, cb: Function) => {
      try {
        const token = await getToken();
        const { error, result, status } = (await axios.post(
          `${baseUrl}/leagues/d/${id}/clone?include=organization,tournament,config.paymentProduct`,
          {
            name: leagueName,
            cloneDivisions: cloneDivisions
          },
          createAuthHeader(token)
        )).data;
        error ? toast.error(error) : toast.success(`Successfully Cloned!`);
        set((state) => {
          state.leagues.push(result);
        });
        cb && cb(result);
        return { error, result };
      } catch (error) {
        showError('Error', 'Clone Error');
        console.error("Error in cloneLeague:", error);
        return { error: "Error cloning league" };
      }
    }
  },

})));

export default useLeagueStore;
